const meta = {
  module: "auth",
  layout: "auth",
  withoutCredentials: true,
};

export default [
  {
    path: `/auth/login`,
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/modules/auth/views/login.vue"),
    meta: {
      ...meta,
    },
  },
  {
    path: `/auth/login-test`,
    name: "login-test",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/modules/auth/views/login-test.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: "/auth/registration",
    name: "registration",
    component: () =>
      import(
        /* webpackChunkName: "registration" */ "@/modules/auth/views/registration.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: "/auth/email-confirmed/:token",
    name: "email-confirmed",
    component: () =>
      import(
        /* webpackChunkName: "email-confirmed-page" */ "@/modules/auth/views/email-confirmed-page.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: "/auth/email-expired",
    name: "email-expired",
    component: () =>
      import(
        /* webpackChunkName: "email-expired-page" */ "@/modules/auth/views/email-expired-page.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: "/auth/email-not-confirmed",
    name: "email-not-valid",
    component: () =>
      import(
        /* webpackChunkName: "email-expired-page" */ "@/modules/auth/views/email-not-valid.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: "/auth/email-sent/:email",
    name: "email-send",
    component: () =>
      import(
        /* webpackChunkName: "email-sent-page" */ "@/modules/auth/views/email-sent-page.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/auth/reset/:token`,
    name: "reset",
    component: () =>
      import(/* webpackChunkName: "Reset" */ "@/modules/auth/views/reset.vue"),
    meta: {
      ...meta,
    },
  },
];
